"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _index = require("@/api/user/index");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      chosenAddressId: 18,
      list: []
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    setDefaultAddress: function setDefaultAddress(id) {
      console.log(id);
    },
    setNewAddress: function setNewAddress() {
      this.$router.push({
        name: 'address-edit',
        params: {
          addressId: -1
        }
      });
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _index.userAddressList)().then(function (res) {
                  if (res.data.data) {
                    _this.list = res.data.data.map(function (val, index) {
                      if (val.is_default == 1) _this.chosenAddressId = val.id;
                      return {
                        id: val.id,
                        isDefault: val.is_default === 1,
                        name: val.contact_name,
                        tel: val.contact_phone,
                        address: val.addressInfo
                      };
                    });
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }(),
    onAdd: function onAdd() {
      this.$router.push("/user/address/add");
    },
    onEdit: function onEdit(item, index) {
      this.$router.push("/user/address/edit/".concat(item.id));
    },
    onSelect: function onSelect() {},
    goBack: function goBack() {
      this.$router.go(-1); // 返回上一层
    }
  },
  components: {}
};
exports.default = _default;